// Definición de defaults

export const defaultSentidoSentencia: SentidoSentenciaProps = {
    idSentidoSentencia:    0,
    descripcion:           '',
    activo:                false,
}

// Creación de interfaces

export interface SentidoSentenciaProps {
    idSentidoSentencia:        number;
    descripcion:             string;
    activo:                  boolean;
}